if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        // Escape the section: Dawn's reveal-on-scroll animation leaves a transform on
        // .product__info-wrapper, which would make position:fixed anchor to it instead
        // of the viewport. Skipped in the editor to keep block-selection mapping intact.
        if (!(window.Shopify && window.Shopify.designMode) && this.parentElement !== document.body) {
          // One bar per page. Both Main product and Featured product can render one, and
          // a page may hold several Featured product sections — every bar is fixed to the
          // same strip of viewport, so they would stack invisibly on top of each other.
          // First one to connect wins; the rest drop out rather than fight for the strip.
          // `:scope >` matters: unmoved bars are still body *descendants*, so a plain
          // querySelector would match this element itself and every bar would remove itself.
          if (document.body.querySelector(':scope > sticky-atc')) {
            this.remove();
            return;
          }
          document.body.appendChild(this);
          return; // appendChild re-runs connectedCallback with the new parent
        }
        this.button = this.querySelector('.sticky-atc__button');
        const target = this.targetElement;
        if (!this.button || !target) return;
        this.button.addEventListener('click', this.scrollToForm.bind(this));
        this.observer = new IntersectionObserver((entries) => {
          const entry = entries[0];
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          this.classList.toggle('sticky-atc--visible', scrolledPast);
        });
        this.observer.observe(target);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      // Re-queried on every use: Dawn may swap the submit button on section re-renders.
      get targetElement() {
        return document.getElementById(this.dataset.target);
      }

      scrollToForm() {
        const target = this.targetElement;
        if (!target) return;
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        target.focus({ preventScroll: true });
        target.scrollIntoView({ behavior, block: 'center' });
      }
    },
  );
}
